export default "__VITE_ASSET__D8I5usD4__"